import { CreateQuotationResponse } from "../../types/rtk/quotations/quotations";
import { apiSlice } from "../_api/api-slice";

interface Agrs {
  chosenRate: number;
}

export const quotations = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    postQuotation: build.mutation<CreateQuotationResponse, Agrs>({
      query: ({ chosenRate }) => ({
        url: `quotations?chosen_rate=${chosenRate}`,
        method: "post",
      }),
    }),
  }),
  overrideExisting: false,
});

export const { usePostQuotationMutation } = quotations;
